export enum USER_GROUP_CLASSIFY {
  LKTD = 11,
  KLKTD = 12
}
